import React from 'react';
import { IconProps } from './Icon';

const Health: React.FunctionComponent<IconProps> = ({
  color,
  height,
  width,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 297 297"
  >
    <g fill={color}>
      <path
        d="M101.15 175.142c6.966 0 14.634.68 21.634 1.966v-20.969h51v37.424c6 2.203 10.381 4.579 14.494 7.567 7.797 5.664 12.082 13.099 12.339 21.254 9.925-2.345 19.028-6.321 26.905-11.737 2.846-1.956 6.262-3.668 8.262-5.137v-58.243L148.047 49.23l-89.263 98.628v35.247c6-1.521 11.468-3.156 17.806-4.884 7.496-2.043 15.815-3.079 24.56-3.079z"
      />
      <path
        d="m148.446 25.313 99.184 110.826h22.621L148.247 0 97.784 55.572V33.139h-37v63.315l-35.583 39.685h22.943zM259.083 214.931c-5.494 0-12.89 2.44-22.289 8.901-17.182 11.811-38.215 17.012-57.433 17.012-15.623 0-30.045-3.435-40.23-9.546-5.046-3.028-5.031-4.039-2.104-4.039 5.878 0 23.504 4.079 35.449 4.079 5.878 0 10.379-.987 11.432-3.934 4.867-13.628-14.001-18.016-33.73-26-14.444-5.848-32.073-10.262-48.861-10.263-6.999 0-13.914.767-20.332 2.517-29.141 7.945-50.199 13.93-56.199 15.873v76.48c12-4.413 25.9-8.642 33.81-8.642 14.516 0 73.253 18.726 106.51 18.726 4.658 0 8.829-.367 12.298-1.204 28.227-6.814 77.232-46.725 90.533-60.351 6.386-6.542 3.86-19.609-8.854-19.609z"
      />
    </g>
  </svg>
);

export default Health;
